module.exports = __webpack_public_path__ + "static/media/customchannel.aaf30508.svg";